import Vue from 'vue'

import router from '../../../router/qyw/merchant'
import store from '../../../store/qyw/merchant'

import initWithAntd from '../../initWithAntd'
import conf from '../../../conf'
import filter from '../../../components/common/filters/index'

Vue.prototype.$checkFunc = (funCode) => {
  if (!funCode) {
    return true
  }

  if (!conf.checkFunCode) {
    return true
  }

  const token = window.localStorage.getItem('token') || ''
  const { dzdPermission } = store.state.myself
  if (funCode === 'bill') {
    return dzdPermission
  }
  if (funCode === 'bills') {
    return token.indexOf('PHONELOGIN_USER_TOKEN_') === 0 && dzdPermission
  }
  return true
}
Vue.use(filter)

// Vue.use(filter)

initWithAntd.newInstance(Vue, router, store)
